import TCollapseTransition from './collapse-transition'

TCollapseTransition.install = Vue => {
  Vue.component(TCollapseTransition.name, TCollapseTransition)
}

export default TCollapseTransition



// WEBPACK FOOTER //
// ./src/module/collapse-transition/index.js